module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Tipo de preço",
      "columns": 6,
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.price.type),
      expression: "options.price.type"
    }],
    staticClass: "form-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options.price, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onChangePriceType]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.priceTypeDI), function(priceType) {
    return _c('option', {
      domProps: {
        "value": priceType
      }
    }, [_vm._v("\n          " + _vm._s(priceType === 'source' ? _vm.$t('priceTypeModule.label') + 'Módulo' : _vm.$t(priceType).label) + "\n        ")])
  })], 2)]), _vm._v(" "), (_vm.isTypePercent) ? _c('form-group', {
    attrs: {
      "label": "Percentual",
      "columns": 6,
      "required": true
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.price.auxiliary),
      expression: "options.price.auxiliary"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.options.price.auxiliary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options.price, "auxiliary", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("%")])])]) : _vm._e(), _vm._v(" "), (_vm.isTypeFixedValue) ? _c('form-group', {
    attrs: {
      "label": "Valor fixo",
      "columns": 6,
      "required": true
    }
  }, [_c('money', _vm._b({
    staticClass: "form-input",
    model: {
      value: (_vm.options.price.auxiliary),
      callback: function($$v) {
        _vm.$set(_vm.options.price, "auxiliary", $$v)
      },
      expression: "options.price.auxiliary"
    }
  }, 'money', _vm.money, false))], 1) : _vm._e(), _vm._v(" "), (_vm.isPriceTypeCustom) ? _c('form-group', {
    attrs: {
      "label": "Método de customização",
      "columns": 6
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.price.custom.method),
      expression: "options.price.custom.method"
    }],
    staticClass: "form-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options.price.custom, "method", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onChangeCustomMethod]
    }
  }, [_c('option', {
    attrs: {
      "value": "fixed"
    }
  }, [_vm._v("Fixo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "percent"
    }
  }, [_vm._v("Percentual sobre preço da fonte")])])]) : _vm._e()], 1), _vm._v(" "), (_vm.isPriceTypeCustom) ? _c('div', {
    staticClass: "l-row"
  }, [(_vm.isPriceCustomMethodPercent) ? _c('form-group', {
    attrs: {
      "label": "Percentual sobre preço da fonte",
      "columns": 6
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.price.custom.percent),
      expression: "options.price.custom.percent"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.price.custom.percent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options.price.custom, "percent", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("%")])])]) : _vm._e(), _vm._v(" "), (_vm.isPriceCustomMethodFixed) ? _c('form-group', {
    attrs: {
      "label": _vm.$t('price.previous.label'),
      "columns": 6,
      "required": true
    }
  }, [_c('money', _vm._b({
    staticClass: "form-input",
    attrs: {
      "disabled": _vm.disabled || !_vm.options.price.custom.previousUpdate
    },
    model: {
      value: (_vm.options.price.previous),
      callback: function($$v) {
        _vm.$set(_vm.options.price, "previous", $$v)
      },
      expression: "options.price.previous"
    }
  }, 'money', _vm.money, false)), _vm._v(" "), _c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.price.custom.previousUpdate),
      expression: "options.price.custom.previousUpdate"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.price.custom.previousUpdate) ? _vm._i(_vm.options.price.custom.previousUpdate, null) > -1 : (_vm.options.price.custom.previousUpdate)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.options.price.custom.previousUpdate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options.price.custom, "previousUpdate", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options.price.custom, "previousUpdate", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options.price.custom, "previousUpdate", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-checkbox__indicator"
  }), _vm._v(" "), _c('span', {
    staticClass: "form-checkbox__text"
  }, [_vm._v("Alterar o preço antigo.")])])], 1) : _vm._e(), _vm._v(" "), (_vm.isPriceCustomMethodFixed) ? _c('form-group', {
    attrs: {
      "label": _vm.$t('price.current.label'),
      "columns": 6,
      "required": true
    }
  }, [_c('money', _vm._b({
    staticClass: "form-input",
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.options.price.current),
      callback: function($$v) {
        _vm.$set(_vm.options.price, "current", $$v)
      },
      expression: "options.price.current"
    }
  }, 'money', _vm.money, false))], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5023fc85","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/batch/updatePrice/Options.vue
// module id = 3155
// module chunks = 0